import { render, staticRenderFns } from "./PosAccountSettings.vue?vue&type=template&id=409780f6"
import script from "./PosAccountSettings.vue?vue&type=script&lang=js"
export * from "./PosAccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports